import React, { useEffect, useState } from "react";
import { Icon, Input, Select, Button, Popover, Checkbox, Switch } from "antd";
import style from "../solo.module.sass";
import cancelSvg from '../../../../../assets/svg/solo/closeBtn.svg';
import "../create/flow.css"
import StringIcon from "../../../../../assets/svg/solo/s.svg"
import JsonIcon from "../../../../../assets/svg/solo/j.svg"
import integerIcon from "../../../../../assets/svg/solo/i.svg"
import booleanIcon from "../../../../../assets/svg/solo/b.svg"
import CodeEditor from "../codeEditor/CodeEditor"
import VariableAcl from "./VariableAcl";
import variableAclIcon from "../../../../../assets/svg/solo/variableAclConfigured.svg"
import emptyVariableAclIcon from "../../../../../assets/svg/solo/variableAclNotConfigured.svg"
import _ from "lodash";

const { Option } = Select;

interface Service {
    serviceName?: string,
    serviceKey?: string
}

const AssistedJourney = (props: any) => {/* eslint-disable */
    const { forms, nodeDetail, elements, widgetDrawer, soloServices, showVariableAcl, setShowVariableAcl, setAclIcon } = props
    const [values, setvalues]: any = useState([])
    const [completion, setCompletion]: any = useState(false);
    const [processDefinitionKey, setProcessDefintionKey]: any = useState(null)
    const [assistedName, setassistedName]: any = useState(null);
    const [name, setName]: any = useState(null)
    const [id, setId]: any = useState(0)
    const [valueCheck, setValueCheck]: any = useState(null)
    const [nodes, setNodes]: any = useState(null);
    const [showAddIcon, setShowAddIcon]: any = useState(true)
    const [nextNode, setNextNode]: any = useState(null);
    const [assistedProperty, setAssistedProperty]: any = useState({ nodeId: null, name: "" })
    const [openDropDownTypes, setOpenDropDownTypes]: any = useState(null)
    const [outputVariables, setOutputVariables]: any = useState(null)
    const [selectedWebhookHandler, setSelectedWebhookHandler]: any = useState(null)
    const [webhookHandlerService, setWebhookHandlerService] = useState<Service>({})
    const [selectedForm, setSelectedForm] = useState(null)
    const [formKey, setFormKey] = useState(null)
    const [findIndex, setFindIndex]: any = useState(null)
    const [selectedType, setSelectedType] = useState("")
    const [disableSave, setDisableSave] = useState(false)
    const [spaceKeyPressed, setSpaceKeyPressed]: any = useState(false)
    const [showCodeEditor, setShowCodeEditor] = useState<boolean>(false)
    const [jsonValue, setJsonValue] = useState(null)
    const [allVariables, setAllVariables] = useState(false)
    const [sessionVariables, setSessionVariables]: any = useState(null)
    const [findJsonIndex, setFindJsonIndex] = useState(0);
    const [variableAcl, setVariableAcl] = useState({});
    const [setupActiveTab, setSetupActiveTab] = useState("freeze")
    const [teardownActiveTab, setTeardownActiveTab] = useState("freeze")
    const variablesTypes = [
        { id: 1, type: "String", src: StringIcon },
        { id: 2, type: "Integer", src: integerIcon },
        { id: 3, type: "Boolean", src: booleanIcon },
        { id: 4, type: "Json", src: JsonIcon }
    ];

    useEffect(() => {
        let targetNodeFind: any;
        const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
        targetNodeFind = elements.filter((el: any) => { return (el.target === nextNode) })
        if (findNextNode.length) {
            setNextNode(findNextNode[0].target)
        } else if (findNextNode.length === 0 && targetNodeFind.length === 0) {
            setNextNode("")
        }
        let arr: any = []
        elements.forEach((e: any) => {
            if (e.data && e.data.type && e.data.type !== "start" && e.data.type !== "error" && e.id !== props.nodeDetail.id) {
                arr.push(e)
                setNodes(arr)
            }
        })
    }, [elements])

    useEffect(() => {
        props.onUpdateProperties(assistedProperty)
    }, [assistedProperty])

    useEffect(() => {
        if (assistedName) {
            setAssistedProperty({
                nodeId: nodeDetail.id,
                name: assistedName,

            })
        }
    }, [assistedName])

    useEffect(() => {
        if (forms) {
            forms.map((f: any) => {
                return (f.formName === selectedForm) &&
                    setFormKey(f.formKey)
            })
        }
    }, [selectedForm])

    useEffect(() => {
        if (soloServices) {
            soloServices.map((s: any) => {
                if (selectedWebhookHandler && selectedWebhookHandler === s.name) {
                    return setWebhookHandlerService({ serviceName: s.name, serviceKey: s.serviceKey })
                }
            })
        }
    }, [selectedWebhookHandler])


    useEffect(() => {
        setSetupActiveTab("freeze")
        setTeardownActiveTab("freeze")
        setAclIcon(emptyVariableAclIcon)
        setShowVariableAcl(false)
        if (nodeDetail.data.propertyDetails) {
            if (nodeDetail.data.propertyDetails.variableAcl?.setup?.freeze || nodeDetail.data.propertyDetails.variableAcl?.setup?.unfreeze ||
                nodeDetail.data.propertyDetails.variableAcl?.setup?.hide || nodeDetail.data.propertyDetails.variableAcl?.setup?.unhide ||
                nodeDetail.data.propertyDetails.variableAcl?.teardown?.freeze || nodeDetail.data.propertyDetails.variableAcl?.teardown?.unfreeze ||
                nodeDetail.data.propertyDetails.variableAcl?.teardown?.hide || nodeDetail.data.propertyDetails.variableAcl?.teardown?.unhide) {
                setAclIcon(variableAclIcon)
            }
            const { propertyDetails } = nodeDetail.data
            let waitingFormName = null
            if (propertyDetails.formKey) {
                const form = forms && forms.find((f: any) => { return f.formKey === nodeDetail.data.propertyDetails.formKey })
                if (form) {
                    waitingFormName = form.formName
                }
            }
            if (nodeDetail.type === "assistedJourney" && propertyDetails && propertyDetails.keyValue) {
                setvalues(propertyDetails.keyValue);
                const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
                if (findNextNode.length) {
                    setNextNode(findNextNode[0].target)
                } else {
                    setNextNode("")
                }
                setName(propertyDetails.name);
                setassistedName(propertyDetails.name);
                setProcessDefintionKey(propertyDetails.processDefinitionKey)
                setCompletion(propertyDetails.completion)
                setShowAddIcon(true)
                setvalues(propertyDetails.keyValue)
                setOutputVariables(propertyDetails.outputVariables)
                setSelectedWebhookHandler(propertyDetails?.webhookHandler?.serviceName)
                setWebhookHandlerService(propertyDetails && propertyDetails.webhookHandler || {})
                setSelectedForm(waitingFormName)
                setFormKey(propertyDetails.formKey || null)
                setSessionVariables(propertyDetails.sessionVariables)
                setAllVariables(propertyDetails.sessionVariables && propertyDetails.sessionVariables.length == 1 && propertyDetails.sessionVariables[0] == "*" ? true : false)
                setVariableAcl(propertyDetails?.variableAcl || {})
            } else {
                const { propertyDetails = {} } = nodeDetail.data
                setShowAddIcon(true)
                if (nodeDetail.type === "assistedJourney" && propertyDetails.inputVariables) {
                    setName(propertyDetails && propertyDetails.name);
                    setassistedName(propertyDetails && propertyDetails.name);
                    const findNextNode = elements.filter((el: any) => { return (el.source === nodeDetail.id) })
                    if (findNextNode.length) {
                        //const nextNode = elements.filter((el: any) => { return el.id === findNextNode[0].target })
                        setNextNode(findNextNode[0].target)
                    } else {
                        setNextNode("")
                    }

                    let arr: any = [];
                    let obj = {};
                    if (propertyDetails.inputVariables) {
                        const keys = Object.keys(propertyDetails.inputVariables && propertyDetails.inputVariables)
                        keys && keys.map((key: any, id: any) => {
                            const findSrc = variablesTypes.findIndex((el: any) => el.type === propertyDetails.inputVariables[key].type)
                            obj = {
                                id: id,
                                key: key,
                                value: propertyDetails.inputVariables[key].value,
                                type: propertyDetails.inputVariables[key].type,
                                src: variablesTypes[findSrc].src
                            }
                            arr.push(obj)
                        })
                    }
                    setId(arr.length)
                    setShowAddIcon(true)
                    setvalues(arr)
                    setProcessDefintionKey(propertyDetails.processDefinitionKey)
                    setCompletion(propertyDetails.completion)
                    setOutputVariables(propertyDetails.outputVariables)
                    setFormKey(propertyDetails.formKey)
                    setSelectedForm(waitingFormName)
                    setSelectedWebhookHandler(propertyDetails?.webhookHandler?.serviceName)
                    setWebhookHandlerService(propertyDetails && propertyDetails.webhookHandler || {})
                    setSessionVariables(propertyDetails.sessionVariables)
                    setAllVariables(propertyDetails.sessionVariables && propertyDetails.sessionVariables.length == 1 && propertyDetails.sessionVariables[0] == "*" ? true : false)
                    setVariableAcl(propertyDetails?.variableAcl || {})
                    setAssistedProperty({
                        nodeId: nodeDetail.id,
                        name: propertyDetails && propertyDetails.name,
                        keyValue: arr,
                        completion: propertyDetails.completion,
                        processDefinitionKey: propertyDetails.processDefinitionKey,
                        nextNode: findNextNode.length ? findNextNode[0].target : "",
                        outputVariables: propertyDetails.outputVariables,
                        selectedWebhookHandler: propertyDetails.webhookHandler ? propertyDetails.webhookHandler.serviceName : "",
                        webhookHandlerService: propertyDetails.webhookHandler ? propertyDetails.webhookHandler : {},
                        formKey: propertyDetails.formKey ? propertyDetails.formKey : null,
                        selectedForm: waitingFormName,
                        sessionVariables: propertyDetails.sessionVariables,
                        variableAcl
                    })
                } else if (propertyDetails) {
                    setShowAddIcon(true)
                    setProcessDefintionKey(propertyDetails.processDefinitionKey || "")
                    setCompletion(propertyDetails.completion || false)
                    setOutputVariables(propertyDetails.outputVariables || [])
                    setName(propertyDetails && propertyDetails.name);
                    setassistedName(propertyDetails && propertyDetails.name);
                    setSelectedWebhookHandler(propertyDetails?.webhookHandler?.serviceName)
                    setWebhookHandlerService(propertyDetails && propertyDetails.webhookHandler || {})
                    setSelectedForm(waitingFormName)
                    setFormKey(propertyDetails.formKey || null)
                    setSessionVariables(propertyDetails.sessionVariables || [])
                    setAllVariables(propertyDetails.sessionVariables && propertyDetails.sessionVariables.length == 1 && propertyDetails.sessionVariables[0] == "*" ? true : false )
                    setVariableAcl(propertyDetails?.variableAcl || {})
                }
            }
        } else if (!nodeDetail.data.propertyDetails) {
            if (nodeDetail.type === "assistedJourney") {
                setName(nodeDetail.id);
                setassistedName(nodeDetail.id);
                setvalues([])
                setNextNode("")
                setProcessDefintionKey("");
                setCompletion(false);
                setShowAddIcon(true);
                setOutputVariables([]);
                setWebhookHandlerService({});
                setSelectedWebhookHandler("")
                setFormKey(null);
                setSelectedForm(null);
                setSessionVariables([]);
                setAllVariables(false);
                setVariableAcl({})
            }
        }
    }, [nodeDetail, widgetDrawer ])

    useEffect(() => {
        if (valueCheck) {
            if (valueCheck && valueCheck.length > 0) {
                setShowAddIcon(true)
            } else {
                setShowAddIcon(false)
            }
        } else if (valueCheck === "") {
            setShowAddIcon(false)
        }
    }, [valueCheck])

    const addParams = () => {
        const value = [...values]
        value.push({ id: id, key: "", value: "", type: "", src: "" })
        setvalues(value)
    }

    const valuesRemove = (i: any) => {
        const value = [...values];
        value.splice(i, 1);
        setvalues(value);
    }

    const handleSpace = (e: any) => {
        if (e.keyCode === 32 || e.keyCode === 8) {
            setSpaceKeyPressed(true)
        } else {
            setSpaceKeyPressed(false)
        }
    };

    const addKey = (e: any, i: any) => {
        const Names = values.map((el: any) => _.camelCase(el.key));
        if (Names) {
            if (Names.splice(0, Names.length + 1).includes(_.camelCase(e.target.value)) && !spaceKeyPressed) {
                const val = [...values]
                val[i].nameCheck = true;
                val[i].key = e.target.value.trim();
                setValueCheck(e.target.value)
                setvalues(val)
                setDisableSave(true)
                setShowAddIcon(false)
            } else {
                const val = [...values];
                values[i].key = e.target.value.trim();
                setValueCheck(e.target.value)
                values[i].nameCheck = false;
                setvalues(val);
                setDisableSave(false)
                setShowAddIcon(true)
            }
        } else {
            const val = [...values];
            values[i].key = e.target.value;
            values[i].nameCheck = false;
            setvalues(val)
        }
    }

    const addValue = (i: any, value: any) => {
        const val = [...values];
        val[i].value = value
        setvalues(val);
    }

    const addType = (e: any, i: any) => {
        const value = [...values];
        if (e.type === "Json") {
            value[i].value = ""
        }
        value[i].type = e.type || "String";
        value[i].src = e.src || StringIcon;
        setvalues(value);
    }

    const saveAssist = () => {
        const oVariables = outputVariables && outputVariables.map((variable: string) => {
            return variable.trim()
        })
        const sVariables = sessionVariables && sessionVariables.map((variable: string) => {
            return variable.trim()
        })
        let KeyValue: any = [];
        let data = {};
        values.map((value: any) => {
            data = {
                key: value.key,
                value: value.value ? value.value.trim() : "",
                type: value.type ? value.type : "String",
                src: value.src ? value.src : StringIcon
            }
            return KeyValue.push(data)
        })
        setAssistedProperty({
            nodeId: nodeDetail.id,
            name: name,
            keyValue: KeyValue,
            completion: completion,
            processDefinitionKey: processDefinitionKey,
            idChange: true,
            nextNode: nextNode,
            outputVariables: oVariables,
            webhookHandler: webhookHandlerService,
            formKey,
            sessionVariables: sVariables,
            variableAcl
        })
        props.setWidgetDrawer(false)
    }

    const SelectedType = (props: any) => {
        const { index, type } = props
        return (
            <div className={style.dropdown}
                onMouseLeave={() => {
                    setOpenDropDownTypes(null)
                }}
            >
                {variablesTypes.map((item: any) => {
                    return (
                        <div
                            onClick={() => {
                                addType(item, index);
                                setOpenDropDownTypes(null)
                            }}
                            key={item.type}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: type === item.type ? "space-between" : "",
                                color: type && type.type === item.type ? "#0F66C8" : "#000610",
                                marginBottom: "-15px"
                            }}>
                            {<img src={item.src} />}
                            <p style={{ marginTop: 13, marginRight: 25, fontSize: "15px" }}>
                                {item.type}
                            </p>
                            {type && type.type === item.type &&
                                < Icon type="check" style={{
                                    marginTop: "18px",
                                    marginRight: "10px",
                                    color: "#0F66C8"
                                }} />}
                        </div>
                    )
                })}
            </div>)
    }


    const closeModal = () => {
        setShowCodeEditor(false)
    }

    return ( <>
        {!showVariableAcl && <>
            <div style={{ display: "flex", flexDirection: "column" }} >
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label}>
                            <label >Name</label>
                        </div>
                        <Input
                            disabled={props.lock}
                            style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: props.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD" }}
                            value={name}
                            placeholder="Enter Node Name"
                            onChange={(e: any) => { setName(e.target.value); setassistedName(e.target.value) }}
                        />
                        {(props.nameCheck || !name) && <p style={{
                            color: "#FF0000",
                            opacity: props.nameCheck || !name ? 1 : 0,
                            position: "relative",
                            textAlign: "center",
                            margin: "5px",
                            fontSize: 14
                        }}>{!name ? "Name shouldn't be empty" : "Name already exist"}</p>}
                    </div>
                </div>
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
            </div>
            <div style={{ maxHeight: window.innerHeight - 350, overflow: "auto" }}>
                <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}
                    >
                        <label >Next Node</label>
                    </div>
                    <Select
                        showSearch
                        onChange={(e: any) => setNextNode(e)}
                        suffixIcon={<Icon style={{ fontSize: "20px", margin: -5 }} type="caret-down" />}
                        disabled={props.lock}
                        value={nextNode || undefined}
                        placeholder="Select the next node"
                        optionLabelProp="label"
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            color: "#000610",
                            fontSize: 15
                        }}
                        mode="default"
                        size="large"
                        filterOption={(input, option: any) => {
                            return (option && option.props)
                                ?
                                option.props.label.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                : false
                        }}
                    >
                        {nodes && nodes.map((el: any) => {
                            return <Option
                                key={el.id}
                                value={el.id}
                                label={el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}>
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div
                                        style={{ display: "flex", flexDirection: "row" }}>
                                        <img alt="icons" src={el.data.icon} />
                                        <p
                                            style={{
                                                marginLeft: "8px",
                                                marginTop: "14px",
                                                color: el.id === nextNode ? "#0F66C8" : "#000610"
                                            }}
                                        >
                                            {el && el.data && el.data.propertyDetails && el.data.propertyDetails && el.data.propertyDetails.name || el.id}
                                        </p>
                                    </div>
                                    {el.id === nextNode &&
                                        < Icon type="check" style={{ color: "#0F66C8" }} />}
                                </div>
                            </Option>
                        })}
                    </Select>
                </div>
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label} style={{ fontSize: "15px", fontWeight: "bold" }}>
                            <label >Request</label>
                        </div>
                    </div>
                </div>
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label}>
                            <label >Process Definition Key</label>
                        </div>
                        <Input
                            disabled={props.lock}
                            style={{ width: "100%", height: "44px", color: "#000610", fontSize: 15, border: "1px solid #909BAD" }}
                            value={processDefinitionKey}
                            placeholder="Enter Process Definition Key"
                            onChange={(e: any) => { setProcessDefintionKey(e.target.value) }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", padding: "10px 18px 0px 18px"}}>
                    <div className={style.label}>
                         <label >Session Variables</label>
                    </div>
                    <div style={{display: "flex", alignItems: "center", paddingTop: "5px"}}>
                        <label className={style.label} style={{ paddingRight: "8px", paddingBottom: "5px"}}>All</label>
                        <Switch defaultChecked={allVariables} checked={allVariables} onChange={(e: any) => { setAllVariables(e); e ? setSessionVariables(["*"]) : setSessionVariables([]) }}/>
                    </div>
                </div>
                {!allVariables && <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px"}}>
                    <Select
                        showSearch={false}
                        disabled={props.lock}
                        mode="tags"
                        autoClearSearchValue={true}
                        style={{
                            borderRadius: 8,
                            color: "black",
                            fontSize: 15
                        }}
                        value={sessionVariables}
                        onChange={(e: any) => setSessionVariables(e)}
                        size="large"
                        className="tagsSelect"
                        dropdownClassName="assistedDropdown"
                        placeholder="Session variables"
                    >
                    </Select>
                </div>}
                {<div>
                    <div className={style.label} style={{ padding: "10px 18px 0px 18px", marginBottom: !props.lock ? 0 : 10 }}>
                        <label style={{ height: 10 }}>Input Variables</label>
                    </div>
                    {/* overflow: "auto", */}
                    <div style={{ border: "none", padding: "0 8px", marginBottom: "10px" }}
                        onMouseLeave={() => {
                            setOpenDropDownTypes(null)
                        }}
                    >
                        {values && values.length > 0 && values.map((element: any, Index: number) => {
                            return (
                                <div
                                    key={Index}
                                    style={{ marginBottom: !props.lock ? 0 : 15 }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: 0, padding: "0px 5px" }}>
                                        <Input
                                            prefix={<></>}
                                            onKeyDown={handleSpace}
                                            disabled={props.lock}
                                            style={{
                                                marginLeft: 4,
                                                height: "44px",
                                                color: "#000610",
                                                fontSize: 15,
                                                border: element.nameCheck ? "1px solid #FF0000" : "1px solid #909BAD"
                                            }}
                                            placeholder="key"
                                            value={element.key || ""}
                                            onChange={(e) => { addKey(e, Index) }}
                                        />
                                        <div style={{
                                            display: "flex",
                                            marginLeft: "16px",
                                            width: "100%",
                                            border: "1px solid #909BAD",
                                            height: "44px",
                                            borderRadius: 8,
                                            position: 'relative'
                                        }}>
                                            <div
                                                onClick={() => {
                                                    !props.lock &&
                                                        setOpenDropDownTypes(openDropDownTypes === element.id ? null : element.id); setFindIndex(Index); setSelectedType(element.type ? element : { type: "String" })
                                                }}
                                            >
                                                <img style={{ cursor: props.lock ? "not-allowed" : "pointer" }} src={element.src || StringIcon} />
                                            </div>
                                            {openDropDownTypes === element.id &&
                                                <Popover
                                                    className="service-type"
                                                    content={<SelectedType index={findIndex} type={selectedType} />}
                                                    overlayClassName="overlay-service-type"
                                                    placement="bottom"
                                                    trigger="hover"
                                                    visible={openDropDownTypes === element.id}
                                                />}
                                            <Input
                                                disabled={props.lock}
                                                style={{
                                                    marginLeft: "-10px",
                                                    height: "40px",
                                                    color: "#000610",
                                                    fontSize: 15,
                                                    flex: "4",
                                                    border: 'none',
                                                }}
                                                placeholder="value"
                                                readOnly={element.type === "Json"}
                                                value={element.value || ""}
                                                onClick={() => { element.type === "Json" && setShowCodeEditor(true); setJsonValue(values.length > 0 ? values[Index].value : " "); setFindJsonIndex(Index) }}
                                                onChange={(e) => { addValue(Index, e.target.value) }}
                                            />
                                            {showCodeEditor &&
                                                <CodeEditor
                                                    handleExpression={addValue}
                                                    id={findJsonIndex}
                                                    lang="Json"
                                                    values={jsonValue}
                                                    close={closeModal}
                                                />}
                                        </div>

                                        {
                                            <div key={element.id}
                                                style={{ display: "flex", justifyContent: "center", marginRight: 3 }}>
                                                {!props.lock && <img
                                                    alt="cancel"
                                                    style={{ height: "65px", marginLeft: 15, cursor: "pointer" }}
                                                    src={cancelSvg}
                                                    onClick={() => { valuesRemove(Index); setShowAddIcon(true) }}
                                                />}
                                            </div>
                                        }
                                    </div>
                                    {element.nameCheck && <p style={{
                                        color: "#FF0000",
                                        opacity: element.nameCheck ? 1 : 0,
                                        position: "relative",
                                        padding: "0px 15px",
                                        fontSize: 14
                                    }}>{"Key already exist"}</p>}
                                </div>
                            )
                        })}
                    </div>
                </div>}
                {showAddIcon && !props.lock && <div
                    style={{
                        marginTop: values && values.length > 0 ? "-10px" : "0px",
                        display: "flex",
                        padding: "0px 13px"
                    }}>
                    <Button
                        style={{ height: "35px" }}
                        type="primary"
                        disabled={props.lock}
                        onClick={() => {
                            addParams();
                            setId((prevState: any) => prevState + 1);
                            setShowAddIcon(false)
                        }}>ADD PARAMETERS</Button>
                </div>}
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label} style={{ fontSize: "15px", fontWeight: "bold" }}>
                            <label >Waiting</label>
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 15px", marginBottom: 20 }}>
                    <div className={style.label} >
                        <label>Waiting Form Screen</label>
                    </div>
                    <Select
                        showSearch
                        suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                        disabled={props.lock}
                        placeholder="Select the form"
                        value={selectedForm || undefined}
                        size="large"
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            //border: "1px solid #CAD5E9",
                            color: "#000610",
                            fontSize: 15,
                        }}
                        optionLabelProp="label"
                        onChange={(e: any) => setSelectedForm(e)}
                        filterOption={(input, option: any) => {
                            return (option && option.props && option.props.children) ?
                                option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                : false
                        }}
                    >
                        {forms && forms.map((item: any) => {
                            return <Option
                                key={item.formId}
                                value={item.formName}
                                label={item?.displayName || item.formName}>
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <p style={{ marginTop: "10px", color: item.formName === selectedForm ? "#0F66C8" : "#000610" }}>
                                        {item?.displayName || item.formName}
                                    </p>
                                    {item.formName === selectedForm &&
                                        < Icon type="check" style={{ color: "#0F66C8" }} />}
                                </div>
                            </Option>
                        })}
                    </Select>
                </div>
                <div style={{ borderBottom: "1px solid rgb(202, 213, 233)", margin: "20px 20px" }}></div>
                <div className={style.conditionInput}>
                    <div style={{ width: "100%" }}>
                        <div className={style.label} style={{ fontSize: "15px", fontWeight: "bold" }}>
                            <label >Completion</label>
                        </div>
                    </div>
                </div>
                <Checkbox checked={completion} disabled={props.lock}
                    onChange={(e: any) => { setCompletion(e.target.checked) }}
                    style={{ padding: "0px 15px 15px 15px" }}
                >Wait for completion
                </Checkbox>
                {completion && <div>
                <div style={{ display: "flex", flexDirection: "column", width: "100%", padding: "0px 15px" }}>
                    <div
                        className={style.label}
                        style={{ color: "#3c434a" }}
                    >
                        <label >Output Variables</label>
                    </div>
                    <Select
                        showSearch={false}
                        disabled={props.lock}
                        mode="tags"
                        autoClearSearchValue={true}
                        style={{
                            borderRadius: 8,
                            color: "#000610",
                            fontSize: 15
                        }}
                        value={outputVariables}
                        onChange={(e: any) => setOutputVariables(e)}
                        size="large"
                        className="tagsSelect"
                        dropdownClassName="assistedDropdown"
                        placeholder="Output variables"
                    >
                    </Select>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "0px 15px 0px 15px",  marginBottom: 20 }}>
                    <div className={style.label} >
                        <label>Response Handler</label>
                    </div>
                    <Select
                        showSearch
                        suffixIcon={<Icon style={{ fontSize: "20px", margin: "-5px" }} type="caret-down" />}
                        disabled={props.lock}
                        placeholder="Select the custom service"
                        value={selectedWebhookHandler || undefined}
                        size="large"
                        style={{
                            width: "100%",
                            borderRadius: 8,
                            //border: "1px solid #CAD5E9",
                            color: "#000610",
                            fontSize: 15,
                        }}
                        optionLabelProp="label"
                        onChange={(e: any) => setSelectedWebhookHandler(e)}
                        filterOption={(input, option: any) => {
                            return (option && option.props && option.props.children) ?
                                option.props.children.props.children[0].props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                : false
                        }}
                    >
                        {soloServices && soloServices.map((item: any) => {
                            return <Option
                                key={item.id}
                                value={item.name}
                                label={item.name}>
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <p style={{ marginTop: "10px", color: item.name === selectedWebhookHandler ? "#0F66C8" : "#000610" }}>
                                        {item.name}
                                    </p>
                                    {item.name === selectedWebhookHandler &&
                                        < Icon type="check" style={{ color: "#0F66C8" }} />}
                                </div>
                            </Option>
                        })}
                    </Select>
                </div>
                </div>}
            </div>
            {<div className={style.footer}>
                {!props.nameCheck && !props.lock && <Button
                    disabled={!name || disableSave}
                    style={{
                        backgroundColor: "#51808C",
                        color: "#FFFFFF",
                        width: "100%",
                        height: 50
                    }}
                    onClick={saveAssist} >APPLY</Button>}
            </div>}
        </>}
            {showVariableAcl && <VariableAcl
                variableAcl={variableAcl}
                setVariableAcl={setVariableAcl}
                teardownActiveTab={teardownActiveTab}
                setTeardownActiveTab={setTeardownActiveTab}
                setupActiveTab={setupActiveTab}
                setSetupActiveTab={setSetupActiveTab}
                setShowVariableAcl={setShowVariableAcl}
                name={name}
                lock={props.lock}>
            </VariableAcl>}
        </>)
}

export default AssistedJourney;